interface SkeletonProps {
  rows?:      number
  className?: string
  style?:     React.CSSProperties
  height?:    string
  width?:     string
}

export default function Skeleton({ rows = 1, className, style, height = '1.2rem', width = '100%' }: SkeletonProps) {
  return (
    <div className={className} style={style}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="skeleton-shimmer"
          style={{
            height,
            width:        i === rows - 1 && rows > 1 ? '60%' : width,
            marginBottom: i < rows - 1 ? '0.75rem' : 0,
          }}
        />
      ))}
    </div>
  )
}
